// Static Assets
import { IItemDetail } from 'api/types/marketplace';
import Title1Line from '../../../assets/images/frames/title1line@2x.png';
// import PaperOutline from '../../../assets/images/icons/paper_outline@2x.png';

interface Props {
  itemDetailObj: IItemDetail;
}

const DescriptionCard = ({ itemDetailObj }: Props) => {
  return (
    <>
      <div className="description-frame">
        <div className="description-wrap">
          <div className="title-wrap">
            <img src={Title1Line} alt="Title2Line" className="img-fluid" />
            <h2 className="title-text">DESCRIPTION</h2>
          </div>
          <div className="description-content">
            <div className="descrption-content-inner">
              <div className="descrption-content-wrap">
                <div className="w-100 d-flex align-items-center justify-content-between sm:flex-col sm:flex-start mb-3 sm:mb-2">
                  <h2 className="description-title">{itemDetailObj.descriptionHeading}</h2>
                  {/* <div className="ticker">
                    <span className="icon-10">
                      <img src={PaperOutline} alt="Paper Outline" className="img-fluid" />
                    </span>
                    12,109
                  </div> */}
                </div>
                <div className="descrption-content-scroll">
                  {itemDetailObj.description.split('\n').map((str, idx) => (
                    <p key={idx}>{str}</p>
                  ))}
                  {/* <ul>
                    <li>+ Relaxed fit</li>
                    <li>+ Crew neck</li>
                    <li>+ Heavy weight, 8.2oz, 26-singles</li>
                    <li>+ 100% combed cotton (heathers 15% viscose)</li>
                  </ul>
                  <p>
                    The Acrocalypse shirt is constructed from a heavy weight, combed cotton. It features a single chest
                    pocket with a woven Acrocalypse label on top.
                  </p>
                  <ul>
                    <li>+ Relaxed fit</li>
                    <li>+ Crew neck</li>
                    <li>+ Heavy weight, 8.2oz, 26-singles</li>
                    <li>+ 100% combed cotton (heathers 15% viscose)</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DescriptionCard;
